/* eslint-disable @typescript-eslint/no-unused-vars */
import React from 'react';
import { TabNavItem, TabNavItemWrapper } from '../styles/cpds-tab-style';

//types
import { CpdsTabNavItemProps } from '../typings';
import { checkValue } from 'src/components/functions';
import { truncate } from 'src/components/common/utils/dynamicClassSelector';

const TabNavigationItem: React.FC<CpdsTabNavItemProps> = (props) => {
  const { name, selected = false, index, onClickItem, children, exClasses } = props;
  const className = checkValue(exClasses) ? exClasses : 'cpds-meta-roman-medium-book-09';

  const handleClick = (event: MouseEvent | KeyboardEvent) => {
    event.preventDefault();
    if (typeof onClickItem === 'function') {
      onClickItem(index, event);
    }
  };

  return (
    <TabNavItemWrapper>
      <TabNavItem className={className} selected={selected} onClick={handleClick}>
        {truncate(name, 18)}
        {/* {children} */}
      </TabNavItem>
    </TabNavItemWrapper>
  );
};

export { TabNavigationItem };
